import React from "react";

interface JobSearchAppliedFiltersProps {
  filterButtonClicked: () => void;
}

const JobSearchAppliedFilters: React.FC<JobSearchAppliedFiltersProps> = () => {
  // Get URL parameters for filters
  const getUrlParams = () => {
    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      return {
        filters: urlParams.getAll("filters") || [],
      };
    }
    return { filters: [] };
  };

  const { filters } = getUrlParams();

  return (
    <div className="flex items-center justify-start h-full">
      {Boolean(filters.length) && (
        <>
          <ul className="flex items-start justify-start content-start gap-4 flex-wrap">
            {filters.map((filter: string, index: number) => {
              // Extract filter name from "group:name" format
              const filterName = filter.split(":")[1] || filter;
              return (
                <li
                  key={index}
                  className="rounded-default bg-Secondary-100 px-2 py-1 text-sm text-Primary-900 font-semibold whitespace-nowrap"
                >
                  {filterName}
                </li>
              );
            })}
          </ul>
        </>
      )}
    </div>
  );
};

export default JobSearchAppliedFilters;
